import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IBadge } from "../types/products";

const API = process.env.REACT_APP_API;

/**
 * Hook para buscar badges do catálogo (core.Badge)
 */
const useBadges = () => {
  const fetch = useFetch();

  return useQuery({
    queryKey: ["badges"],
    queryFn: () => {
      return fetch(`${API}/api/semeadora/badges/`, {
        method: "GET",
      }) as Promise<IBadge[]>;
    },
    onError: (error) => {
      console.error("Erro ao carregar badges", error);
    },
  });
};

export default useBadges;
